@if (isLoading) {
<app-loading-spinner [text]="Trades"></app-loading-spinner>
} @if (trades$ | async; as trades) {
<div class="text-class" class="page-height overflow-auto py-4 px-4">
  @if (isWideScreen) {
  <app-trades-item-laptop-desktop
    [data]="trades"
  ></app-trades-item-laptop-desktop>
  } @else { @for (item of trades; track item) {
  <div>
    <app-trades-item [item]="item"></app-trades-item>
  </div>
  } }
</div>
}
